// ===== BLOG ARTICLE — auto TOC + share buttons (isolated, self-contained) =====
document.addEventListener('DOMContentLoaded', () => {
  try {
    // ---- Auto-generate Table of Contents from H2 headings inside the article body ----
    const content = document.getElementById('article-content');
    const tocEl = document.getElementById('article-toc');

    if (content && tocEl) {
      const headings = content.querySelectorAll('h2');
      if (headings.length > 0) {
        const usedIds = new Set();
        headings.forEach((heading, index) => {
          let slug = heading.textContent
            .trim()
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-');
          if (!slug) slug = `section-${index + 1}`;
          while (usedIds.has(slug)) slug += `-${index}`;
          usedIds.add(slug);
          heading.id = slug;

          const link = document.createElement('a');
          link.href = `#${slug}`;
          link.textContent = heading.textContent;
          tocEl.appendChild(link);
        });
        tocEl.hidden = false;
      }
    }

    // ---- Share buttons ----
    document.querySelectorAll('[data-share]').forEach(button => {
      button.addEventListener('click', async () => {
        const url = window.location.href;
        const title = document.title;
        const type = button.getAttribute('data-share');

        if (type === 'copy') {
          try {
            await navigator.clipboard.writeText(url);
            const original = button.textContent;
            button.textContent = 'Link copied';
            setTimeout(() => { button.textContent = original; }, 2000);
          } catch (err) {
            console.error('Copy failed:', err);
          }
          return;
        }

        const shareUrls = {
          whatsapp: `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`,
          facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
          x: `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`
        };
        if (shareUrls[type]) window.open(shareUrls[type], '_blank', 'noopener,noreferrer');
      });
    });

  } catch (err) {
    console.error('Blog article script failed to initialize:', err);
  }
});